import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import moment from "moment";

import { FormField } from "../../../sharedComponents/formField";
import { required } from "../../../constants/formValidators";
import { PanelBody, PanelFooter } from "../../../sharedComponents/filterPanel";
import { saveNutritionGoals, createNutritionGoals } from "../../../store/actions/index";
import { goalFields } from "./formHelper";

const SetGoals = ({ initialValues, handleSubmit, saveNutritionGoals, onUpdate, toggle, createNutritionGoals }) => {
	const validateForm = (values) => {
		const successHandler = (event) => {
			onUpdate(event);
		};

		initialValues && initialValues.id
			? saveNutritionGoals(
				{ ...values, date: moment(values.date).format("YYYY/MM/DD"), id: initialValues.id },
				successHandler
			)
			: createNutritionGoals({ ...values, date: moment().format("YYYY/MM/DD") }, successHandler);
	};

	return (
		<form className="flex-fill d-flex flex-column" onSubmit={handleSubmit(validateForm)}>
			<PanelBody>
				<div className="row">
					{initialValues &&
						goalFields &&
						goalFields.length > 0 &&
						goalFields.map(({ name, label, step }, index) => {
							return (
								<Field
									key={index}
									label={label}
									name={name}
									type="number"
									formGroupClass="col-12"
									component={FormField}
									validate={[required]}
									min={0}
									step={step}
								/>
							);
						})}
				</div>
			</PanelBody>
			<PanelFooter className="sticky-footer py-0">
				<div className="text-right pt-3 pb-3">
					<button className="btn btn-default" type="button" onClick={toggle}>
						Cancel
					</button>
					<button className="btn btn-primary-dark text-uppercase" type="submit">
						Save
					</button>
				</div>
			</PanelFooter>
		</form>
	);
};

const mapDispatchToProps = {
	saveNutritionGoals,
	createNutritionGoals
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "SetGoalsForm",
		enableReinitialize: true
	})(SetGoals)
);
